<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
     class="lucide lucide-sparkles">
  <defs>
    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(92)">
      <stop offset="3.26%" style="stop-color:#6911D8;stop-opacity:1"/>
      <stop offset="53.86%" style="stop-color:#DD816D;stop-opacity:1"/>
      <stop offset="99.2%" style="stop-color:#AF5D8C;stop-opacity:1"/>
      <stop offset="134.68%" style="stop-color:#BB2625;stop-opacity:1"/>
    </linearGradient>
  </defs>
  <path
    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
    stroke="url(#grad1)"/>
  <path d="M20 3v4"/>
  <path d="M22 5h-4"/>
  <path d="M4 17v2"/>
  <path d="M5 18H3"/>
</svg>
